import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../helpers/api';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';
import notifications from '../../redux/notifications/actions';

const districtsApi = new Api('districts/default');
const applicantsApi = new Api('dashboard/applicants');

function* loadData() {
  try {
    const { districts, applicants } = yield all({
      districts: call(sendRequest, districtsApi.load, notifications.REQUEST_ERROR),
      applicants: call(sendRequest, applicantsApi.load, {}, notifications.REQUEST_ERROR),
    });

    if (districts && districts.data && districts.data.success && districts.data.success.data) {
      const { id } = districts.data.success.data;

      let hasApplicants = false;

      if (applicants && applicants.data && applicants.data.success && applicants.data.success.data) {
        hasApplicants = !!applicants.data.success.data.totalCount;
      }

      yield put(actions.loadDataSuccess({ defaultDistrictId: id, hasApplicants }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
